<template>
  <div class="comenzi-wrapper">
  <DxDataGrid ref="gridRef" :data-source="comenziData" key-expr="Id" show-borders :column-auto-width="false"
    @context-menu-preparing="onContextMenuPreparing"
    @row-dbl-click="(e: any) => onOpenOrder(e.data)"
    :allow-column-resizing="true" :column-resizing-mode="'widget'" :allow-column-reordering="true"
    :show-column-lines="true" :show-row-lines="true" :row-alternation-enabled="true" :hover-state-enabled="true"
    :filter-row="{ visible: true }"
    :column-chooser="{ enabled: true, mode: 'select', allowSearch: true }" :paging="{ pageSize: 10 }" height="100%"
    class="comenzi-grid" @cell-prepared="onCellPrepared">
    <DxScrolling show-scrollbar="always" />
    <DxRemoteOperations :filtering="true" :paging="true" :sorting="true" />
    <DxPager :visible="true" :allowed-page-sizes="[10, 50, 100]" :show-page-size-selector="true" :show-info="true" :show-navigation-buttons="true" />
    <DxStateStoring :enabled="true" type="custom" :custom-save="onGridStateSaving" :custom-load="onGridStateLoading" />

    <!-- ── Buton Deschide Comanda (fix la început) ── -->
    <DxColumn caption="" width="50" :fixed="true" fixed-position="left" :allow-sorting="false" :allow-filtering="false" :allow-resizing="false"
      cell-template="deschideCellTemplate" />

    <!-- ── Coloane VIZIBILE implicit ── -->
    <DxColumn data-field="DataComenzii" caption="Data" data-type="date" format="dd.MM.yyyy" />
    <DxColumn data-field="Cod" caption="Cod" />
    <DxColumn data-field="Agent.Nume" caption="Agent" />
    <DxColumn data-field="Client.Nume" caption="Partener" />
    <DxColumn data-field="Observatii" caption="Observatii" />
    <DxColumn data-field="Proiect.Nume" caption="Proiect" />
    <DxColumn data-field="ValoareComanda" caption="Valoare" data-type="number" :format="formatRO" />
    <DxColumn data-field="TotalComanda" caption="Total" data-type="number" :format="formatRO" />
    <DxColumn data-field="Valuta.Simbol" caption="Valuta" />
    <DxColumn data-field="Tva" caption="TVA" data-type="number" :format="formatRO" />
    <DxColumn data-field="Facturat" caption="Facturat" data-type="boolean" cell-template="boolDaNuCellTemplate" />
    <DxColumn caption="Rezervat" :width="130" alignment="center" :allow-sorting="false" :allow-filtering="false"
      cell-template="rezervatCellTemplate" />
    <DxColumn data-field="Stare" caption="Stare" cell-template="stareCellTemplate" />

    <!-- ── Coloane ASCUNSE (disponibile în Column Chooser) ── -->
    <DxColumn data-field="Nume" caption="Denumire" :visible="false" />
    <DxColumn data-field="LivrareDirectaFurnizor" caption="Livrare Directă Furnizor" data-type="boolean" :visible="false" cell-template="boolDaNuCellTemplate" />
    <DxColumn data-field="Motive" caption="Motive" :visible="false" />
    <DxColumn data-field="Tipcomanda" caption="Tip Comandă" :visible="false" />
    <DxColumn data-field="Numar" caption="Număr" :visible="false" />
    <DxColumn data-field="NumeContract" caption="Nume Contract" :visible="false" />
    <DxColumn data-field="NumarContract" caption="Număr Contract" :visible="false" />
    <DxColumn data-field="Contract.NumeContract" caption="Contract" :visible="false" />
    <DxColumn data-field="PathContract" caption="Path Contract" :visible="false" />
    <DxColumn data-field="Facturator.Nume" caption="Facturator" :visible="false" />
    <DxColumn data-field="ExpeditieTipId" caption="Expeditie Tip" :visible="false" />
    <DxColumn data-field="Discount" caption="Discount" data-type="number" :format="formatRO" :visible="false" />
    <DxColumn data-field="FacturareZiDinLuna" caption="Zi Facturare" :visible="false" />
    <DxColumn data-field="Curs" caption="Curs" :visible="false" />
    <DxColumn data-field="PretCurs" caption="Pret Curs" :visible="false" />
    <DxColumn data-field="PreturiCalculate" caption="Preturi Calculate" :visible="false" />
    <DxColumn data-field="BonDeConfirmare" caption="Bon Confirmare" :visible="false" />
    <DxColumn data-field="Delegat.Delegat" caption="Delegat" :visible="false" />
    <DxColumn data-field="Punct.Nume" caption="Punct" :visible="false" />
    <DxColumn data-field="DataStartProductie" caption="Data Start Productie" data-type="date" :visible="false" />
    <DxColumn data-field="TimpExecutie" caption="Timp Executie" :visible="false" />
    <DxColumn data-field="Prioritate" caption="Prioritate" :visible="false" />
    <DxColumn data-field="Explicatie" caption="Explicatie" :visible="false" />
    <DxColumn data-field="TermenLivrare" caption="Termen Livrare" data-type="date" :visible="false" />
    <DxColumn data-field="Destinatar" caption="Destinatar" :visible="false" />
    <DxColumn data-field="ExpCurierNume" caption="Curier Nume" :visible="false" />
    <DxColumn data-field="Activa" caption="Activa" :visible="false" />
    <DxColumn data-field="Anulata" caption="Anulata" :visible="false" />
    <DxColumn data-field="Inchisa" caption="Inchisa" :visible="false" />
    <DxColumn data-field="Suspendata" caption="Suspendata" :visible="false" />
    <DxColumn data-field="Terminata" caption="Terminata" :visible="false" />
    <DxColumn data-field="UserCreare" caption="User Creare" :visible="false" />
    <DxColumn data-field="DataCreare" caption="Data Creare" data-type="date" :visible="false" />
    <DxColumn data-field="UserModificare" caption="User Modificare" :visible="false" />
    <DxColumn data-field="DataModificare" caption="Data Modificare" data-type="date" :visible="false" />

    <!-- ── Template culori Stare ── -->
    <template #stareCellTemplate="{ data }">
      <span :style="getStareStyle(data.value)">{{ getStareLabel(data.value) }}</span>
    </template>

    <!-- ── Template Comandat/Rezervat (câmpuri deja atașate pe rând de buildComenziStore) ── -->
    <template #rezervatCellTemplate="{ data }">
      <span :style="getRezervatStyle(data.data)">{{ getRezervatLabel(data.data) }}</span>
    </template>

    <!-- ── Template Da/Nu colorat (Facturat, Livrare Directă Furnizor) ── -->
    <template #boolDaNuCellTemplate="{ data }">
      <span :class="data.value ? 'badge-boolean-da' : 'badge-boolean-nu'">{{ data.value ? 'Da' : 'Nu' }}</span>
    </template>

    <!-- ── Toolbar cu buton Adăugare ── -->
    <DxToolbar>
      <DxItem location="after" template="adaugareBtn" />
      <DxItem name="columnChooserButton" />
    </DxToolbar>
    <template #adaugareBtn>
      <DxButton icon="plus" type="success" hint="Adăugare" @click="onAdaugare" />
    </template>

    <DxColumn data-field="Proiect.Cod" caption="PO" width="140" />
    <template #deschideCellTemplate="{ data }">
      <DxButton icon="eyeopen" hint="Deschide Comanda" type="default" styling-mode="outlined"
        class="deschide-btn" @click="() => onOpenOrder(data.data)" />
    </template>

  </DxDataGrid>
  </div>

  <!-- Popup Afișare Comenzi Furnizori -->
  <DxPopup v-model:visible="showFurnizoriPopup" :show-title="false" :show-close-button="false"
    :width="900" :height="520" :drag-enabled="true" @hidden="showFurnizoriPopup = false"
    :wrapper-attr="{ class: 'doc-popup-no-padding' }">
    <template #content>
      <div class="popup-shell">
        <div class="popup-grad-header">
          <i class="dx-icon dx-icon-taskcomplete popup-hdr-icon" />
          <div class="popup-hdr-texts">
            <span class="popup-hdr-title">Comenzi furnizori asociate</span>
            <span class="popup-hdr-sub">Comandă sursă: {{ selectedContextOrder?.Cod }}</span>
          </div>
          <button class="popup-close-x" @click="showFurnizoriPopup = false">×</button>
        </div>
        <div class="popup-body">
          <DxDataGrid :data-source="poFurnizoriList" key-expr="Id" :show-borders="false"
            :show-column-lines="false" :show-row-lines="true"
            :row-alternation-enabled="true" :hover-state-enabled="true"
            :column-auto-width="false" height="420"
            @row-dbl-click="(e: any) => onDeschidePO(e.data)">
            <DxColumn data-field="Cod" caption="Cod PO" :width="150" />
            <DxColumn data-field="Client.Nume" caption="Furnizor" />
            <DxColumn data-field="DataComenzii" caption="Data" data-type="date"
              format="dd.MM.yyyy" :width="110" />
            <DxColumn data-field="Stare" caption="Stare" :width="140"
              cell-template="starePOCell" />
            <DxColumn data-field="TotalComanda" caption="Total" data-type="number"
              :format="formatRO" :width="140" alignment="right" cell-template="totalPOCell" />
            <DxColumn data-field="Valuta.Simbol" caption="Val." :width="60" alignment="center" />
            <DxColumn caption="" :width="52" :allow-sorting="false" :allow-filtering="false"
              :allow-resizing="false" cell-template="deschidePOCell" />
            <template #starePOCell="{ data }">
              <span :style="getStareStyle(data.value)">{{ getStareLabel(data.value) }}</span>
            </template>
            <template #totalPOCell="{ data }">
              <span class="cell-total">{{ data.value != null ? formatRO(data.value) : '—' }}</span>
            </template>
            <template #deschidePOCell="{ data }">
              <DxButton icon="eyeopen" styling-mode="text" hint="Deschide PO"
                @click="onDeschidePO(data.data)" />
            </template>
          </DxDataGrid>
          <div v-if="isLoadingFurnizori" class="popup-footer-hint">Se încarcă comenzile furnizori...</div>
          <div v-else-if="!isLoadingFurnizori && poFurnizoriList.length === 0" class="popup-footer-hint">
            <i class="dx-icon dx-icon-info" /> Nicio comandă furnizor asociată acestei comenzi.
          </div>
        </div>
      </div>
    </template>
  </DxPopup>

  <!-- Popup Generare Factură Proiect -->
  <DxPopup v-model:visible="showFacturaProiectPopup" :show-title="false" :drag-enabled="true"
    :show-close-button="false" :close-on-outside-click="false" :width="720" :height="620"
    :wrapper-attr="{ class: 'doc-popup-no-padding' }">
    <template #content>
      <div class="popup-shell">
        <div class="popup-grad-header">
          <i class="dx-icon dx-icon-group popup-hdr-icon" />
          <div class="popup-hdr-texts">
            <span class="popup-hdr-title">Generează Factură Proiect</span>
            <span class="popup-hdr-sub">
              Proiect: {{ selectedContextOrder?.Proiect?.Cod }}
              <span v-if="selectedContextOrder?.Proiect?.Nume"> — {{ selectedContextOrder?.Proiect?.Nume }}</span>
            </span>
          </div>
          <button class="popup-close-x" @click="showFacturaProiectPopup = false">×</button>
        </div>
        <div class="genpo-body">
          <div class="genpo-form">
            <div class="genpo-row2">
              <div class="genpo-field genpo-span2">
                <label class="genpo-label">Tip Document <span class="genpo-required">*</span></label>
                <DxSelectBox v-model:value="facturaProiectDraft.TipDocumentId"
                  :data-source="dsTipuriFacturi"
                  display-expr="Nume" value-expr="Id"
                  :search-enabled="true" search-expr="Nume"
                  placeholder="Selectează tipul facturii..." />
              </div>
              <div class="genpo-field">
                <label class="genpo-label">Data <span class="genpo-required">*</span></label>
                <DxDateBox v-model:value="facturaProiectDraft.Data"
                  display-format="dd.MM.yyyy" type="date" />
              </div>
              <div class="genpo-field">
                <label class="genpo-label">Cont Bancă <span class="genpo-optional">(opțional)</span></label>
                <DxSelectBox v-model:value="facturaProiectDraft.ContBancaCasaId"
                  :data-source="dsBanciConturi"
                  :display-expr="(item: any) => item ? `${item.Cod || ''} – ${item.CodIban || item.Nume || ''}`.trim() : ''"
                  value-expr="Id"
                  :search-enabled="true" search-expr="Cod"
                  :show-clear-button="true"
                  placeholder="Selectează contul bancar..." />
              </div>
              <div class="genpo-field genpo-span2">
                <label class="genpo-label">Observații <span class="genpo-optional">(opțional)</span></label>
                <DxTextBox v-model:value="facturaProiectDraft.Observatii"
                  :show-clear-button="true" placeholder="Observații factură proiect..." />
              </div>
            </div>
            <p class="genpo-hint">
              <i class="dx-icon dx-icon-info" style="font-size:13px;vertical-align:middle" />
              Selectează comenzile din proiect care intră în factură — toate au fost bifate implicit.
              Comenzile selectate trebuie să aibă același PO (Nr. Contract).
            </p>
            <DxDataGrid :data-source="dsComenziProiect" key-expr="Id" :show-borders="false"
              :show-column-lines="false" :show-row-lines="true" :row-alternation-enabled="true"
              :hover-state-enabled="true" height="220"
              @content-ready="onComenziProiectContentReady"
              @selection-changed="onComenziProiectSelectionChanged">
              <DxSelection mode="multiple" show-check-boxes-mode="always" />
              <DxColumn data-field="Cod" caption="Comandă" :width="130" />
              <DxColumn data-field="DataComenzii" caption="Data" data-type="date" format="dd.MM.yyyy" :width="100" alignment="center" />
              <DxColumn data-field="NumarContract" caption="PO (Nr. Contract)" />
              <DxColumn data-field="TotalComanda" caption="Total" data-type="number" :format="formatRO" :width="120" alignment="right" />
            </DxDataGrid>
          </div>
        </div>
        <div class="genpo-footer">
          <DxButton text="Anulează" styling-mode="outlined" :disabled="isGenerandFacturaProiect"
            @click="showFacturaProiectPopup = false" />
          <DxButton :text="isGenerandFacturaProiect ? 'Se generează...' : 'Generează Factură Proiect'" type="default"
            :disabled="isGenerandFacturaProiect || !facturaProiectDraft.TipDocumentId || selectedComenziIds.length === 0" @click="onGenereazaFacturaProiect" />
        </div>
      </div>
    </template>
  </DxPopup>

  <!-- Popup Adaugare -->
  <PopupAdaugareDetaliu v-model:visible="showAddPopup" :tip-comanda="selectedTipComanda"
    :comanda-id="selectedComandaId" @saved="onSaved" />

  <!-- Popup Istoric Documente Generate -->
  <DxPopup :visible="showDocumentePopup" :show-title="false" :show-close-button="false"
    :width="860" :height="540" :drag-enabled="true" @hidden="showDocumentePopup = false"
    :wrapper-attr="{ class: 'doc-popup-no-padding' }">
    <template #content>
      <div class="popup-shell">
        <div class="popup-grad-header">
          <i class="dx-icon dx-icon-doc popup-hdr-icon" />
          <div class="popup-hdr-texts">
            <span class="popup-hdr-title">Documente generate</span>
            <span class="popup-hdr-sub">Comandă: {{ selectedContextOrder?.Cod }}</span>
          </div>
          <button class="popup-close-x" @click="showDocumentePopup = false">×</button>
        </div>

        <div class="popup-body">
          <DxDataGrid
            :data-source="dsDocumente" key-expr="Id"
            :show-borders="false" :show-column-lines="false" :show-row-lines="true"
            :row-alternation-enabled="true" :hover-state-enabled="true"
            :column-auto-width="false" height="420"
            @row-click="onDocRowClick"
          >
            <DxColumn data-field="TipCod" caption="Tip" :width="85" />
            <DxColumn data-field="TipNume" caption="Denumire tip" />
            <DxColumn data-field="ComandaCod" caption="Comandă" :width="110" />
            <DxColumn data-field="Numar" caption="Număr" :width="130" />
            <DxColumn data-field="Data" caption="Data" data-type="date" format="dd.MM.yyyy" :width="100" />
            <DxColumn data-field="Total" caption="Total" data-type="number" :format="formatRO" :width="130" alignment="right" cell-template="totalDocCell" />
            <DxColumn data-field="Anulat" caption="Anulat" data-type="boolean" :width="75" cell-template="anulatCell" />
            <template #totalDocCell="{ data }">
              <span class="cell-total">{{ data.value != null ? formatRO(data.value) : '—' }}</span>
            </template>
            <template #anulatCell="{ data }">
              <span v-if="data.value" class="badge-anulat">DA</span>
              <span v-else class="badge-activ">—</span>
            </template>
          </DxDataGrid>
        </div>

        <div v-if="isLoadingDocumente" class="popup-footer-hint">Se încarcă documentele...</div>
        <div v-else-if="dsDocumente.length === 0" class="popup-footer-hint">
          <i class="dx-icon dx-icon-info" /> Niciun document generat pentru această comandă.
        </div>
        <div v-else class="popup-footer-hint">
          <i class="dx-icon dx-icon-info" /> Include și documentele altor comenzi cu același PO (Proiect) — coloana „Comandă" arată sursa. Click pe un rând pentru a deschide documentul într-un tab nou
        </div>
      </div>
    </template>
  </DxPopup>

  <!-- Popup Detalii Document -->
  <DxPopup :visible="showDocumentViewPopup" :show-title="false" :show-close-button="false"
    :width="980" :height="660" :drag-enabled="true" @hidden="showDocumentViewPopup = false"
    :wrapper-attr="{ class: 'doc-popup-no-padding' }">
    <template #content>
      <div class="popup-shell">
        <div class="popup-grad-header">
          <i class="dx-icon dx-icon-doc popup-hdr-icon" />
          <div class="popup-hdr-texts">
            <span class="popup-hdr-title">
              {{ selectedDocument?.Tip?.Cod }} {{ selectedDocument?.Numar }}
            </span>
            <span class="popup-hdr-sub">{{ selectedDocument?.Tip?.Nume }}</span>
          </div>
          <span v-if="selectedDocument?.Anulat" class="badge-anulat-header">ANULAT</span>
          <button class="popup-close-x" @click="showDocumentViewPopup = false">×</button>
        </div>

        <div class="popup-meta-strip">
          <div class="meta-block">
            <span class="meta-block-label">Data</span>
            <span class="meta-block-value">{{ formatDocDate(selectedDocument?.Data) }}</span>
          </div>
          <div class="meta-divider" />
          <div class="meta-block">
            <span class="meta-block-label">Valoare</span>
            <span class="meta-block-value">{{ formatDocMoney(selectedDocument?.Valoare) }}</span>
          </div>
          <div class="meta-divider" />
          <div class="meta-block">
            <span class="meta-block-label">TVA</span>
            <span class="meta-block-value">{{ formatDocMoney(selectedDocument?.ValoareTva) }}</span>
          </div>
          <div class="meta-divider" />
          <div class="meta-block">
            <span class="meta-block-label">Total</span>
            <span class="meta-block-value meta-block-total">{{ formatDocMoney(selectedDocument?.Total) }}</span>
          </div>
        </div>

        <div class="popup-body">
          <DxDataGrid
            :data-source="dsLinii" key-expr="Id"
            :show-borders="false" :show-column-lines="false" :show-row-lines="true"
            :row-alternation-enabled="true" :hover-state-enabled="true"
            :column-auto-width="false" height="510"
          >
            <DxColumn data-field="Produs.Cod" caption="Cod" :width="105" />
            <DxColumn data-field="Produs.Nume" caption="Produs" :calculate-display-value="getLinieNume" />
            <DxColumn data-field="Cantitate" caption="Cant." data-type="number" :format="formatRO" :width="85" alignment="right" />
            <DxColumn data-field="PretUnitar" caption="Preț unitar" data-type="number" :format="formatRO" :width="115" alignment="right" />
            <DxColumn data-field="Tva" caption="TVA %" data-type="number" :width="75" alignment="center" />
            <DxColumn data-field="Valoare" caption="Valoare" data-type="number" :format="formatRO" :width="120" alignment="right" />
            <DxColumn data-field="ValoareTva" caption="Val. TVA" data-type="number" :format="formatRO" :width="110" alignment="right" />
            <DxColumn data-field="Total" caption="Total" data-type="number" :format="formatRO" :width="120" alignment="right" cell-template="totalLinieCell" />
            <template #totalLinieCell="{ data }">
              <span class="cell-total">{{ data.value != null ? formatRO(data.value) : '—' }}</span>
            </template>
          </DxDataGrid>
        </div>
      </div>
    </template>
  </DxPopup>
</template>

<script lang="ts" setup>
import { ref, shallowRef, watch, onMounted } from 'vue';
import DxDataGrid, { DxColumn, DxRemoteOperations, DxStateStoring, DxToolbar, DxItem, DxScrolling, DxSelection, DxPager } from 'devextreme-vue/data-grid';
import DxButton from 'devextreme-vue/button';
import DxPopup from 'devextreme-vue/popup';
import DxSelectBox from 'devextreme-vue/select-box';
import DxDateBox from 'devextreme-vue/date-box';
import DxTextBox from 'devextreme-vue/text-box';
import DataSource from 'devextreme/data/data_source';
import ODataStore from 'devextreme/data/odata/store';
import CustomStore from 'devextreme/data/custom_store';
import AppSetting from '@/settings/appSettings';
import notify from 'devextreme/ui/notify';
import { custom } from 'devextreme/ui/dialog';
import ProComenziService from '@/services/Comercial/ProComenzi';
import DOC_DocumenteService from '@/services/Documente/DOC_Documente';
import PopupAdaugareDetaliu from './PopupAdaugareDetaliu.vue';

interface Filter { category: number | null; start: string; end: string; }
interface OrderData { [key: string]: any; }

const props = defineProps<{ filters: Filter }>();
const emit = defineEmits<{ (e: 'openOrder', order: OrderData): void }>();

const comenziData = ref<DataSource | null>(null);
const showAddPopup = ref(false);
const selectedTipComanda = ref<number | null>(null);
const selectedComandaId = ref('');
const gridRef = ref<any>(null);

function onAdaugare() {
  showAddPopup.value = true;
}

// Apelat din PRO_ComenziView la revenirea pe listă după deschiderea unei comenzi — gridul
// rămâne montat (v-show, nu v-if), deci textul de căutare din filter-row ar rămâne altfel
// vizibil la nesfârșit pe coloană.
function clearColumnFilters() {
  gridRef.value?.instance?.clearFilter('row');
}

defineExpose({ clearColumnFilters });

function onGridStateSaving(state: any) {
  const cleaned = { ...state };
  delete cleaned.filterValue;
  if (Array.isArray(cleaned.columns)) {
    cleaned.columns = cleaned.columns.map((c: any) => {
      const { filterValue, filterValues, ...rest } = c;
      return rest;
    });
  }
  localStorage.setItem('grid-comenzi-state', JSON.stringify(cleaned));
}
function onGridStateLoading() {
  const raw = localStorage.getItem('grid-comenzi-state');
  return raw ? JSON.parse(raw) : null;
}

const STARE_COLORS: Record<string, { background: string; color: string }> = {
  'inasteptare': { background: '#f5f3ff', color: '#6d28d9' },
  'confirmata':  { background: '#eff6ff', color: '#1d4ed8' },
  'inlucru':     { background: '#fef3c7', color: '#92400e' },
  'finalizata':  { background: '#ecfdf5', color: '#065f46' },
  'anulata':     { background: '#fef2f2', color: '#991b1b' },
};

const STARE_LABELS: Record<string, string> = {
  'InAsteptare': 'In Asteptare',
  'InLucru':     'In Lucru',
};
function getStareLabel(stare: string | null | undefined): string {
  return STARE_LABELS[stare ?? ''] ?? (stare ?? '');
}

function getStareStyle(stare: string | null | undefined): Record<string, string> {
  const key = (stare ?? '').toLowerCase().trim();
  const theme = STARE_COLORS[key] ?? { background: '#f1f5f9', color: '#475569' };
  return {
    background: theme.background,
    color: theme.color,
    padding: '4px 12px',
    borderRadius: '20px',
    fontWeight: '700',
    fontSize: '11px',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    display: 'inline-block',
    whiteSpace: 'nowrap',
  };
}

function getRezervatLabel(row: any): string {
  if (row?.CantitateComandataSumar == null) return '—';
  return `${formatRO(row.CantitateComandataSumar)} / ${formatRO(row.CantitateRezervataSumar)}`;
}

function getRezervatStyle(row: any): Record<string, string> {
  const base = {
    padding: '3px 10px',
    borderRadius: '20px',
    fontWeight: '700',
    fontSize: '11px',
    display: 'inline-block',
    whiteSpace: 'nowrap',
  };
  const total = row?.CantitateComandataSumar;
  const rezervat = row?.CantitateRezervataSumar;
  if (total == null || total <= 0 || !(rezervat > 0)) {
    return { ...base, background: '#f1f5f9', color: '#64748b' };
  }
  if (rezervat >= total) {
    return { ...base, background: '#ecfdf5', color: '#065f46' };
  }
  return { ...base, background: '#fef3c7', color: '#92400e' };
}

// ── Store cu sumar rezervări atașat pe fiecare rând, la nivel de pagină încărcată ──
function buildComenziStore(url: string): CustomStore {
  const baseStore = new ODataStore({
    url,
    key: 'Id',
    version: 4,
    beforeSend: (e: any) => {
      e.headers = {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt"),
      };
      e.params.$expand = 'Agent($select=Nume),Client($select=Nume),Proiect($select=Cod,Nume),Valuta($select=Simbol),Contract($select=NumeContract,NumarContract),Facturator($select=Nume),Punct($select=Nume),Delegat($select=Delegat)';
    },
  });

  return new CustomStore({
    key: 'Id',
    load: async (loadOptions: any) => {
      const result: any = await baseStore.load(loadOptions);
      const rows: any[] = Array.isArray(result) ? result : (result.data ?? []);
      const totalCount: number | undefined = Array.isArray(result) ? undefined : result.totalCount;

      const ids: string[] = rows.map((r: any) => r.Id).filter(Boolean);
      if (ids.length > 0) {
        try {
          const resp = await ProComenziService.getSumarRezervari(ids);
          const dict = resp.data ?? {};
          // Normalizare case-insensitive + conversie explicită la string: GUID-urile din
          // OData și cele din dicționarul REST (Dictionary<Guid,...>) pot diferi ca literă
          // mare/mică sau ca tip la momentul comparării.
          const sumar = new Map(Object.keys(dict).map(k => [String(k).toLowerCase(), dict[k]]));
          rows.forEach((row: any) => {
            const info = sumar.get(String(row.Id ?? '').toLowerCase());
            row.CantitateComandataSumar = info?.CantitateTotal ?? null;
            row.CantitateRezervataSumar = info?.CantitateRezervata ?? null;
          });
        } catch {
          rows.forEach((row: any) => {
            row.CantitateComandataSumar = null;
            row.CantitateRezervataSumar = null;
          });
        }
      }

      return totalCount !== undefined ? { data: rows, totalCount } : rows;
    },
    totalCount: (loadOptions: any) => baseStore.totalCount(loadOptions),
    byKey: (key: any) => baseStore.byKey(key),
  });
}

watch(() => props.filters, (filters) => {
  const queryParams: string[] = [];
  if (filters.category !== null) queryParams.push(`Tipcomanda=${filters.category}`);
  if (filters.start) queryParams.push(`DataStart=${filters.start}`);
  if (filters.end) queryParams.push(`DataEnd=${filters.end}`);

  const url = AppSetting.API_Url_ComercialOdata + 'PRO_Comenzi' + (queryParams.length ? `?${queryParams.join('&')}` : '');

  comenziData.value = new DataSource({
    store: buildComenziStore(url),
    paginate: true,
    pageSize: 15,
  });
}, { immediate: true });

function onCellPrepared(e: any) {
  if (e.cellElement && (e.rowType === 'data' || e.rowType === 'header')) {
    e.cellElement.style.setProperty('padding-top', '0px', 'important');
    e.cellElement.style.setProperty('padding-bottom', '0px', 'important');
  }
}

function onOpenOrder(order: OrderData) {
  emit('openOrder', order);
}

function onSaved(commandData: Record<string, any>) {
  comenziData.value?.reload();
  if (commandData?.Id) {
    emit('openOrder', { ...commandData, _isNew: true });
  }
}

// ── Context menu + documente generate ──
const selectedContextOrder = ref<any>(null);
const showDocumentePopup = ref(false);
const showDocumentViewPopup = ref(false);
const selectedDocument = ref<any>(null);
const dsDocumente = shallowRef<any[]>([]);
const isLoadingDocumente = ref(false);
const dsLinii = shallowRef<any>(null);

const isDuplicating = ref(false);
const isImpartind = ref(false);
const isGenerandStorno = ref(false);

const showFurnizoriPopup = ref(false);
const isLoadingFurnizori = ref(false);
const poFurnizoriList = ref<any[]>([]);

const tipuriFurnizoriSet = ref<Set<number>>(new Set());
const categoriiLoaded = ref(false);

const dsTipuriFacturi = shallowRef<DataSource | null>(null);
const dsBanciConturi = shallowRef<DataSource | null>(null);
const dsComenziProiect = shallowRef<DataSource | null>(null);
const selectedComenziIds = ref<string[]>([]);

const showFacturaProiectPopup = ref(false);
const isGenerandFacturaProiect = ref(false);
const facturaProiectDraft = ref<{ TipDocumentId: string | null; Data: Date; ContBancaCasaId: string | null; Observatii: string }>({
  TipDocumentId: null, Data: new Date(), ContBancaCasaId: null, Observatii: '',
});

function getErrMsg(err: any): string {
  if (err?.response?.data) {
    const data = err.response.data;
    if (typeof data === 'string') return data;
    if (data.error?.message) return data.error.message;
    if (data.Message) return data.Message;
    if (data.ExceptionMessage) return data.ExceptionMessage;
    if (data.title) return data.title;
  }
  return err?.message ?? 'A apărut o eroare.';
}

async function onImparteComanda(order: any) {
  if (isImpartind.value) return;
  const ok = await custom({
    title: 'Confirmare împărțire comandă',
    messageHtml: `<div style="padding:4px 0">Comanda <b>${order.Cod}</b> va fi împărțită în două:<br><br>
      • Cantitățile rezervate rămân pe comanda curentă<br>
      • Cantitățile nerezervate sunt mutate pe o comandă nouă<br>
      • Ambele comenzi păstrează același PO<br><br>
      Ești sigur că vrei să continui?</div>`,
    buttons: [
      { text: 'Da, împarte', type: 'default', onClick: () => true },
      { text: 'Renunță', stylingMode: 'outlined', onClick: () => false },
    ],
  }).show();
  if (!ok) return;
  isImpartind.value = true;
  try {
    const resp = await ProComenziService.imparteComanda(order.Id);
    const { ComandaNoua } = resp.data;
    comenziData.value?.reload();
    setTimeout(() => notify(`Comanda a fost împărțită. Comanda nouă: ${ComandaNoua?.Cod ?? ''}`, 'success', 4000), 150);
    if (ComandaNoua?.Id) emit('openOrder', { ...ComandaNoua, _isNew: false });
  } catch (err: any) {
    setTimeout(() => notify(getErrMsg(err), 'error', 4000), 150);
  } finally {
    isImpartind.value = false;
  }
}

async function onGenereazaStorno(order: any, liniiIds?: string[]) {
  if (isGenerandStorno.value) return;
  const estePartial = liniiIds && liniiIds.length > 0;
  const ok = await custom({
    title: 'Generare comandă storno client',
    messageHtml: estePartial
      ? `<div style="padding:4px 0">Se generează storno pentru <b>${liniiIds!.length} linie(i) selectate</b> din comanda <b>${order.Cod}</b>.<br>Comanda storno va fi creată cu starea <b>Confirmată</b>.<br><br>Continui?</div>`
      : `<div style="padding:4px 0">Se generează comanda storno pentru <b>toate liniile</b> din comanda <b>${order.Cod}</b>.<br>Comanda storno va fi creată cu starea <b>Confirmată</b>.<br><br>Continui?</div>`,
    buttons: [
      { text: 'Da, generează', type: 'default', onClick: () => true },
      { text: 'Renunță', stylingMode: 'outlined', onClick: () => false },
    ],
  }).show();
  if (!ok) return;
  isGenerandStorno.value = true;
  try {
    const resp = await ProComenziService.genereazaStorno(order.Id, liniiIds);
    const storno = resp.data;
    comenziData.value?.reload();
    notify(`Comandă storno generată: ${storno?.Cod ?? ''}`, 'success', 3000);
    if (storno?.Id) emit('openOrder', { ...storno, _isNew: false });
  } catch (err: any) {
    notify(getErrMsg(err), 'error', 4000);
  } finally {
    isGenerandStorno.value = false;
  }
}

async function onDuplicaComanda(order: any, pastreazaPO: boolean) {
  if (isDuplicating.value) return;
  isDuplicating.value = true;
  try {
    const resp = await ProComenziService.duplicaComanda(order.Id, pastreazaPO);
    const comandaNoua = resp.data;
    comenziData.value?.reload();
    notify(`Comanda a fost duplicată: ${comandaNoua?.Cod ?? ''}`, 'success', 3000);
    if (comandaNoua?.Id) emit('openOrder', { ...comandaNoua, _isNew: false });
  } catch (err: any) {
    notify(getErrMsg(err), 'error', 4000);
  } finally {
    isDuplicating.value = false;
  }
}

async function onAfiseazaComenziFurnizori(order: any) {
  selectedContextOrder.value = order;
  poFurnizoriList.value = [];
  showFurnizoriPopup.value = true;
  isLoadingFurnizori.value = true;
  try {
    const resp = await ProComenziService.getPOuriByComanda(order.Id);
    poFurnizoriList.value = resp.data?.value ?? [];
  } catch {
    poFurnizoriList.value = [];
  } finally {
    isLoadingFurnizori.value = false;
  }
}

function onDeschidePO(po: any) {
  showFurnizoriPopup.value = false;
  emit('openOrder', po);
}

// Coduri TipComanda pentru comenzi storno — aceleași ca în backend (vezi și
// isComandaStorno din GridComandaDetalii.vue). TipComanda=9 ("Comenzi Retururi către
// Furnizori") are TipFurnizor=true la fel ca o comandă furnizor normală (TipComanda=5) —
// fără excluderea explicită, generarea automată de comenzi furnizori putea "nimeri" pe
// categoria de retur dacă aceasta apărea prima în listă, punând greșit Tipcomanda=9 în loc
// de 5 pe comenzile generate.
const TIPURI_STORNO = [3, 9];

async function loadCategorii() {
  if (categoriiLoaded.value) return;
  try {
    const resp = await ProComenziService.getCategoriiComenzi();
    const toate = resp.data?.value ?? [];
    const furnizoriNestorno = toate.filter((c: any) => c.TipFurnizor === true && !TIPURI_STORNO.includes(Number(c.TipComanda)));
    tipuriFurnizoriSet.value = new Set(furnizoriNestorno.map((c: any) => Number(c.TipComanda)));
  } catch {
    tipuriFurnizoriSet.value = new Set();
  } finally {
    categoriiLoaded.value = true;
  }
}

onMounted(() => { loadCategorii(); });

function buildDsTipuriFacturi() {
  const token = localStorage.getItem('ERA_Jwt') ?? '';
  dsTipuriFacturi.value = new DataSource({
    store: new ODataStore({
      url: AppSetting.API_Url_DocumenteOdata + 'DOC_Tipuri',
      key: 'Id', version: 4,
      beforeSend: (e: any) => { e.headers = { Authorization: 'Bearer ' + token }; },
    }),
    select: ['Id', 'Cod', 'Nume'],
    filter: [
      [['EsteCreanta', '=', true], 'or', ['EsteObligatie', '=', true]],
      'and', ['AreCasa', '=', false],
      'and', ['AreBanca', '=', false],
    ],
    sort: [{ selector: 'Nume', desc: false }],
    paginate: true, pageSize: 50,
  });
}

function buildDsBanciConturi() {
  const token = localStorage.getItem('ERA_Jwt') ?? '';
  dsBanciConturi.value = new DataSource({
    store: new ODataStore({
      url: AppSetting.API_Url_DocumenteOdata + 'ERP_BanciConturi',
      key: 'Id', version: 4,
      beforeSend: (e: any) => { e.headers = { Authorization: 'Bearer ' + token }; },
    }),
    select: ['Id', 'Cod', 'Nume', 'CodIban'],
    filter: ['Activ', '=', true],
    sort: [{ selector: 'Cod', desc: false }],
    paginate: true, pageSize: 50,
  });
}

function buildDsComenziProiect(proiectId: string) {
  const token = localStorage.getItem('ERA_Jwt') ?? '';
  dsComenziProiect.value = new DataSource({
    store: new ODataStore({
      url: AppSetting.API_Url_ComercialOdata + 'PRO_Comenzi',
      key: 'Id', version: 4,
      beforeSend: (e: any) => { e.headers = { Authorization: 'Bearer ' + token }; },
    }),
    select: ['Id', 'Cod', 'DataComenzii', 'NumarContract', 'TotalComanda'],
    filter: [
      ['ProiectId', '=', proiectId],
      'and', ['Stare', '=', 'InLucru'],
      'and', ['Tipcomanda', '<>', 3],
      'and', ['Tipcomanda', '<>', 9],
    ],
    sort: [{ selector: 'DataComenzii', desc: false }],
    paginate: false,
  });
}

async function onOpenFacturaProiectPopup(order: any) {
  if (!dsTipuriFacturi.value) buildDsTipuriFacturi();
  if (!dsBanciConturi.value) buildDsBanciConturi();
  selectedContextOrder.value = order;
  facturaProiectDraft.value = { TipDocumentId: null, Data: new Date(), ContBancaCasaId: null, Observatii: '' };
  selectedComenziIds.value = [];
  if (order?.ProiectId) buildDsComenziProiect(order.ProiectId);
  showFacturaProiectPopup.value = true;
}

function onComenziProiectContentReady(e: any) {
  // Selectate implicit toate comenzile eligibile la încărcare — userul poate debifa
  // ce nu vrea să includă (comportamentul vechi era "toate automat", păstrat ca default).
  if (selectedComenziIds.value.length === 0) {
    const ids = (e.component.getDataSource()?.items() ?? []).map((c: any) => c.Id);
    if (ids.length > 0) {
      selectedComenziIds.value = ids;
      e.component.selectRows(ids, false);
    }
  }
}

function onComenziProiectSelectionChanged(e: any) {
  selectedComenziIds.value = e.selectedRowKeys;
}

async function onGenereazaFacturaProiect() {
  if (!facturaProiectDraft.value.TipDocumentId || !selectedContextOrder.value?.ProiectId) return;
  if (selectedComenziIds.value.length === 0) {
    notify('Selectați cel puțin o comandă din listă.', 'error', 4000);
    return;
  }
  isGenerandFacturaProiect.value = true;
  try {
    const rezultat = await DOC_DocumenteService.genereazaFacturaProiect({
      ProiectId: selectedContextOrder.value.ProiectId,
      TipDocumentId: facturaProiectDraft.value.TipDocumentId,
      Data: facturaProiectDraft.value.Data,
      ContBancaCasaId: facturaProiectDraft.value.ContBancaCasaId || null,
      Observatii: facturaProiectDraft.value.Observatii || null,
      ComandaIds: selectedComenziIds.value,
    });
    showFacturaProiectPopup.value = false;
    const doc = rezultat.data?.Document;
    const avertismente: string[] = rezultat.data?.Avertismente ?? [];
    const numarMsg = doc?.Numar ? ` Nr: ${doc.Numar}` : '';
    notify(`Factura de proiect a fost generată cu succes.${numarMsg}`, 'success', 4000);
    if (avertismente.length > 0)
      setTimeout(() => notify(avertismente[0], 'warning', 6000), 400);
  } catch (err: any) {
    notify(getErrMsg(err), 'error', 5000);
  } finally {
    isGenerandFacturaProiect.value = false;
  }
}

function onContextMenuPreparing(e: any) {
  if (e.target !== 'content' || e.row?.rowType !== 'data') return;
  const order = e.row.data;

  const isFurnizor = tipuriFurnizoriSet.value.has(Number(order.Tipcomanda));
  const stare = (order.Stare ?? '') as string;
  const starePermiteFactura = stare === 'InLucru';
  // Împărțirea (rezervat/nerezervat) nu ține de starea InLucru — se poate face oricând comanda
  // e activă; blocajul real ("toate produsele sunt deja complet rezervate, nimic de mutat") e
  // validat de backend la click, cu mesaj clar (PRO_ComenziRepository.ImparteComanda).
  const starePermiteImpartire = !['Anulata', 'Finalizata'].includes(stare);

  e.items = [
    {
      text: 'Duplicare, PO nou',
      icon: 'copy',
      onItemClick: () => onDuplicaComanda(order, false),
    },
    {
      text: 'Duplicare, păstrare PO',
      icon: 'copy',
      onItemClick: () => onDuplicaComanda(order, true),
    },
    {
      text: 'Împarte cf. cantități rezervate',
      icon: 'splitcells',
      disabled: !starePermiteImpartire,
      onItemClick: () => onImparteComanda(order),
    },
    {
      text: 'Afișare comenzi furnizori',
      icon: 'find',
      onItemClick: () => onAfiseazaComenziFurnizori(order),
    },
    {
      beginGroup: true,
      text: 'Generează comandă storno (toate liniile)',
      icon: 'revert',
      onItemClick: () => onGenereazaStorno(order),
    },
    {
      text: 'Generează factură proiect...',
      icon: 'group',
      visible: false, // ascuns temporar, la cerere — funcționalitatea (selecție comenzi + validare PO unic) e completă în cod, dar rămâne de finalizat/testat altă dată
      disabled: !starePermiteFactura,
      onItemClick: () => onOpenFacturaProiectPopup(order),
    },
    {
      beginGroup: true,
      text: 'Documente generate',
      icon: 'doc',
      onItemClick: async () => {
        selectedContextOrder.value = order;
        dsDocumente.value = [];
        showDocumentePopup.value = true;
        isLoadingDocumente.value = true;
        try {
          const resp = await ProComenziService.getDocumenteGenerate(order.Id);
          dsDocumente.value = resp.data ?? [];
        } catch {
          dsDocumente.value = [];
        } finally {
          isLoadingDocumente.value = false;
        }
      },
    },
  ];
}

function onDocRowClick(e: any) {
  // Nume fix de fereastră — browserul reutilizează același tab la apeluri succesive,
  // în loc să deschidă un tab nou de fiecare dată; Documente.vue adaugă documentul
  // ca tab intern nou (vezi mounted() → openDocumentDetailTab din query ?id=).
  window.open('/documente?id=' + e.data.Id, 'era_documente_tab');
}

function formatRO(val: number | null | undefined): string {
  if (val == null) return '';
  return val.toLocaleString('ro-RO', { maximumFractionDigits: 10 });
}

function formatDocDate(val: string | null | undefined): string {
  if (!val) return '—';
  return new Date(val).toLocaleDateString('ro-RO', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

function formatDocMoney(val: number | null | undefined): string {
  if (val == null) return '—';
  return val.toLocaleString('ro-RO', { maximumFractionDigits: 10 });
}

function getLinieNume(row: any): string {
  return row?.Produs?.Nume || row?.Nume || '—';
}
</script>

<style scoped>

/* ── Layout ── */
.comenzi-wrapper {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #f8f9fc;
}

.comenzi-grid {
  flex: 1;
  min-height: 0;
  margin: 4px 12px 12px;
  border-radius: 8px;
  overflow: hidden;
}


.comenzi-wrapper :deep(.dx-scrollbar-hoverable .dx-scrollable-scroll) {
  opacity: 1 !important;
}

.comenzi-wrapper :deep(.dx-scrollbar-vertical .dx-scrollable-scroll) {
  width: 10px !important;
}

.comenzi-wrapper :deep(.dx-scrollbar-horizontal .dx-scrollable-scroll) {
  height: 10px !important;
}

.comenzi-wrapper :deep(.dx-scrollable-scroll-content) {
  background-color: #ff6a4a !important;
  border-radius: 6px !important;
}

.comenzi-wrapper :deep(.dx-scrollbar-vertical),
.comenzi-wrapper :deep(.dx-scrollbar-horizontal) {
  background-color: #ffe4dc !important;
}

.comenzi-wrapper :deep(.dx-datagrid-header-panel) {
  padding: 3px 6px !important;
}

.comenzi-wrapper :deep(.dx-toolbar) {
  height: 32px !important;
}

.comenzi-wrapper :deep(.dx-toolbar-items-container) {
  height: 32px !important;
}

.comenzi-wrapper :deep(.dx-toolbar .dx-button) {
  height: 27px !important;
  width: 27px !important;
  min-width: unset !important;
}

.comenzi-wrapper :deep(.dx-toolbar .dx-button .dx-icon) {
  font-size: 15px !important;
  width: 15px !important;
  height: 15px !important;
}

.comenzi-wrapper :deep(.dx-datagrid-column-chooser-button) {
  height: 27px !important;
  width: 27px !important;
}

.comenzi-wrapper :deep(.deschide-btn) {
  height: 30px !important;
  width: 30px !important;
  min-width: unset !important;
  line-height: 30px !important;
}

.comenzi-wrapper :deep(.deschide-btn .dx-icon) {
  font-size: 16px !important;
  line-height: 30px !important;
}

.comenzi-wrapper :deep(.dx-datagrid-header-panel .dx-texteditor-input) {
  height: 26px !important;
  min-height: unset !important;
  padding-top: 3px !important;
  padding-bottom: 3px !important;
}

.comenzi-wrapper :deep(.dx-datagrid-header-panel .dx-texteditor) {
  height: 26px !important;
}

.comenzi-wrapper :deep(.dx-datagrid-filter-row td) {
  padding-top: 3px !important;
  padding-bottom: 3px !important;
}

.comenzi-wrapper :deep(.dx-datagrid-filter-row .dx-texteditor) {
  height: 26px !important;
}

.comenzi-wrapper :deep(.dx-datagrid-filter-row .dx-texteditor-input) {
  height: 26px !important;
  min-height: unset !important;
  padding-top: 3px !important;
  padding-bottom: 3px !important;
}

/* ── Popup shell ── */
.popup-shell {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #f8f9fc;
  overflow: hidden;
}

/* ── Gradient header ── */
.popup-grad-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 18px;
  background: linear-gradient(90deg, #ff2c21, #ff6a4a);
  flex-shrink: 0;
}

.popup-hdr-icon {
  font-size: 22px;
  color: #fff;
}

.popup-hdr-texts {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
}

.popup-hdr-title {
  font-size: 15px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 0.3px;
  line-height: 1.2;
}

.popup-hdr-sub {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.85);
  line-height: 1.3;
}

.popup-close-x {
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.4);
  border-radius: 6px;
  color: #fff;
  font-size: 18px;
  line-height: 1;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.15s;
}

.popup-close-x:hover {
  background: rgba(255, 255, 255, 0.3);
}

/* ── Meta strip (popup 2) ── */
.popup-meta-strip {
  display: flex;
  align-items: center;
  padding: 10px 20px;
  background: #fff;
  border-bottom: 1px solid #f1f5f9;
  flex-shrink: 0;
  gap: 0;
}

.meta-block {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 0 20px 0 0;
}

.meta-block + .meta-block {
  padding-left: 20px;
}

.meta-block-label {
  font-size: 11px;
  font-weight: 600;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  line-height: 1;
}

.meta-block-value {
  font-size: 14px;
  font-weight: 500;
  color: #334155;
  line-height: 1.3;
}

.meta-block-total {
  color: #059669;
  font-weight: 700;
  font-size: 15px;
}

.meta-divider {
  width: 1px;
  height: 28px;
  background: #e5e7eb;
  margin-right: 20px;
  flex-shrink: 0;
}

/* ── Body ── */
.popup-body {
  flex: 1;
  min-height: 0;
  padding: 12px;
  overflow: hidden;
}

/* ── Footer hint ── */
.popup-footer-hint {
  padding: 6px 16px 8px;
  font-size: 11px;
  color: #94a3b8;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 4px;
}

/* ── Cell templates ── */
.cell-total {
  font-weight: 700;
  color: #059669;
}

.badge-anulat {
  display: inline-block;
  background: #fef2f2;
  color: #991b1b;
  padding: 2px 8px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.badge-activ {
  color: #94a3b8;
}

.badge-boolean-da {
  display: inline-block;
  background: #ecfdf5;
  color: #065f46;
  padding: 2px 8px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.badge-boolean-nu {
  display: inline-block;
  background: #fef2f2;
  color: #991b1b;
  padding: 2px 8px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* ── Popup Generare Comenzi Furnizori ── */
.genpo-body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 20px;
  background: #f8f9fc;
}
.genpo-form {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.08);
  padding: 18px 20px 14px;
}
.genpo-row2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px 18px;
}
.genpo-field {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.genpo-span2 {
  grid-column: span 2;
}
.genpo-label {
  font-size: 11px;
  font-weight: 600;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.genpo-required { color: #ef4444; }
.genpo-optional {
  color: #94a3b8;
  font-weight: 400;
  text-transform: none;
  letter-spacing: 0;
}
.genpo-hint {
  margin: 12px 0 0;
  font-size: 12px;
  color: #64748b;
  line-height: 1.5;
}
.genpo-checkbox-linii {
  margin-top: 4px;
  font-size: 12px;
}
.genpo-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 14px 20px;
  border-top: 1px solid #f1f5f9;
  background: #fff;
  flex-shrink: 0;
}

.badge-anulat-header {
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.5);
  color: #fff;
  padding: 3px 12px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-right: 8px;
}
</style>

<style>
.doc-popup-no-padding .dx-popup-content {
  padding: 0 !important;
}

.comenzi-wrapper .dx-row > td {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  font-size: 11px !important;
  line-height: 1.1 !important;
}

.comenzi-wrapper .dx-datagrid-headers .dx-header-row td {
  height: 24px !important;
}

</style>
